import React, { useState, useEffect, useRef } from "react";

const reviews = [
  {
    quote: "Professional, patient, and provided quality service!",
    job: "Gardner, KS",
    name: "David W.",
    date: "September 10, 2025",
    professionalism: 5.0,
    communication: 5.0,
    quality: 5.0,
  },
  {
    quote:
      "The team was responsive and professional and it was a pleasure working with them. The job was done in a timely manner and the finished product was excellent. I would hire them again and give them my unreserved recommendation.",
    job: "Leawood, KS",
    name: "Pro Referral Customer",
    date: "June 16, 2025",
    professionalism: 5.0,
    communication: 5.0,
    quality: 5.0,
  },
  {
    quote:
      "We had a great experience with Hayden Home Services! They were quick to respond, very professional, and did an excellent job on our fence tear out and install. We will definitely be using them again for future projects!",
    job: "Fence Tear Out and Install, Olathe, KS",
    name: "J.D.",
    date: "Jun 1, 2025",
    professionalism: 5.0,
    communication: 5.0,
    quality: 5.0,
  },
  {
    quote:
      "The most professional and quality work anyone has ever done on my home! So very thankful we went with them for our fixes!",
    job: "Shower Install & Paint/Trim Work, Olathe, KS",
    name: "James & Emily D.",
    date: "March 25, 2025",
    professionalism: 5.0,
    communication: 5.0,
    quality: 5.0,
  },
  {
    quote:
      "Great experience with this installer! Quick response and the installation was great!",
    job: "Vanity Installation, Olathe, KS",
    name: "Pro Referral Customer",
    date: "March 16, 2025",
    professionalism: 5.0,
    communication: 5.0,
    quality: 5.0,
  },
  {
    quote: "",
    job: "Screen Door Installation, Overland Park, KS",
    name: "Pro Referral Customer",
    date: "February 4, 2025",
    professionalism: 5.0,
    communication: 5.0,
    quality: 5.0,
  },
  {
    quote:
      "Hayden Home Services was professional, easy to communicate with, and did a great job assembling my granddaughters’ large swingset. I would definitely hire them again for any projects we might have.",
    job: "Play Set Assembly, Westwood Hills, KS",
    name: "Pro Referral Customer",
    date: "December 24, 2024",
    professionalism: 5.0,
    communication: 5.0,
    quality: 5.0,
  },
  {
    quote:
      "I was contacted almost immediately for my mailbox installation. The communication was excellent, professional and friendly. Ryan did a great job with the installation and answered all questions I had. I will not hesitate to use them again!",
    job: "Mailbox Post Installation & Handyman Services, Lenexa, KS",
    name: "Linda H.",
    date: "October 19, 2024",
    professionalism: 5.0,
    communication: 5.0,
    quality: 5.0,
  },
];

const Reviews: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const reviewListRef = useRef<HTMLDivElement>(null);

  const nextReview = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % reviews.length);
  };

  const prevReview = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + reviews.length) % reviews.length
    );
  };

  useEffect(() => {
    const interval = setInterval(nextReview, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (reviewListRef.current) {
      reviewListRef.current.style.transform = `translateX(-${
        currentIndex * 100
      }%)`;
    }
  }, [currentIndex]);

  const renderStars = (rating: number) => {
    return (
      <div className="flex">
        {Array.from({ length: 5 }, (_, i) => (
          <svg
            key={i}
            className={`w-4 h-4 ${
              i < rating ? "text-yellow-500" : "text-gray-300"
            }`}
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.375 4.243a1 1 0 00.95.69h4.462c.969 0 1.371 1.24.588 1.81l-3.614 2.624a1 1 0 00-.364 1.118l1.375 4.243c.3.921-.755 1.688-1.54 1.118L10 14.347a1 1 0 00-1.175 0l-3.614 2.624c-.785.57-1.84-.197-1.54-1.118l1.375-4.243a1 1 0 00-.364-1.118L1.171 9.67c-.783-.57-.381-1.81.588-1.81h4.462a1 1 0 00.95-.69l1.375-4.243z" />
          </svg>
        ))}
      </div>
    );
  };

  return (
    <section id="reviews" className="py-20 bg-gray-100">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center text-[#1E3A8A] mb-8">
          Reviews
        </h2>
        <div className="relative overflow-hidden">
          <div
            className="flex transition-transform duration-500"
            ref={reviewListRef}
          >
            {reviews.map((review, index) => (
              <div key={index} className="min-w-full px-4">
                <blockquote className="w-3/4 mx-auto text-xl italic text-center">
                  {review.quote}
                  <footer className="w-3/4 mx-auto mt-4 text-lg text-center">
                    {review.job} <br></br>- {review.name}
                  </footer>
                </blockquote>
                <div className="mt-4 text-center">
                  <div className="flex justify-center items-center mb-2">
                    <span className="mr-2">Professionalism:</span>
                    {renderStars(review.professionalism)}
                  </div>
                  <div className="flex justify-center items-center mb-2">
                    <span className="mr-2">Communication:</span>
                    {renderStars(review.communication)}
                  </div>
                  <div className="flex justify-center items-center">
                    <span className="mr-2">Quality of work:</span>
                    {renderStars(review.quality)}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <button
            className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md"
            onClick={prevReview}
          >
            &lt;
          </button>
          <button
            className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md"
            onClick={nextReview}
          >
            &gt;
          </button>
        </div>
        <div className="flex justify-center mt-4">
          {reviews.map((_, index) => (
            <div
              key={index}
              className={`w-2 h-2 mx-1 rounded-full ${
                currentIndex === index ? "bg-[#1E3A8A]" : "bg-gray-400"
              }`}
            ></div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
